export interface Form {
  submitted: boolean;
  dirty: { [key: string]: boolean };
}

export const validationReady = (form: Form, field: string) =>
  form.submitted || form.dirty[field];
